import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

/**
 * In-app access denied (sidebar + modules stay visible).
 * STAFF / no-web-app users still use /auth/access-denied.
 */
@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [RouterLink, ButtonModule],
  template: `
    <section class="pp-page">
      <div class="pp-page__header">
        <div class="pp-page__titles">
          <h1>Access denied</h1>
          <p class="pp-sub">
            You don’t have permission to view this page. Choose another module from the
            sidebar or go to the dashboard.
          </p>
        </div>
        <div class="pp-page__actions">
          <a
            routerLink="/app/dashboard"
            pButton
            label="Go to Dashboard"
            class="p-button-rounded"></a>
        </div>
      </div>
    </section>
  `,
})
export class AccessDeniedComponent {}
